enum LetterState {
  WrongLetter,
  WrongPosition,
  Correct
}

export default LetterState;
